import React, { useLayoutEffect, useState } from 'react';
import classNames from 'classnames';

import { CollapseTextProps } from './collapse-text.type';

export const CollapseText = ({ text, collapseText, expandText }: CollapseTextProps) => {
  const descriptionText = React.useRef<HTMLSpanElement>(null);
  const [isExpandedDescription, setIsExpandedDescription] = useState(false);
  const [showViewMoreButton, setShowViewMoreButton] = useState(false);
  useLayoutEffect(() => {
    const checkShowMoreButton = () => {
      if (isExpandedDescription) return true;
      return !!descriptionText.current && descriptionText.current.offsetHeight < descriptionText.current.scrollHeight;
    };

    setShowViewMoreButton(checkShowMoreButton());
  }, [isExpandedDescription]);
  return (
    <p>
      <span
        ref={descriptionText}
        className={classNames('text-body-s -mt-2 text-secondary', {
          'line-clamp-2': !isExpandedDescription,
        })}>
        {text}
      </span>
      {showViewMoreButton && (
        <span
          className='self-end whitespace-nowrap text-linkBold-s -mt-2 text-secondary ml-1'
          role='button'
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && setIsExpandedDescription(!isExpandedDescription)}
          onClick={() => setIsExpandedDescription(!isExpandedDescription)}>
          {isExpandedDescription ? collapseText : expandText}
        </span>
      )}
    </p>
  );
};
